<template>
  <section class="mx-3 lg:mx-0 max-w-screen-2xl">
    <div class="mt-10 lg:w-3/5 mx-auto">
      <div v-if="isLoading">
        <business-overview-loader />
      </div>

      <div v-else>
        <div
          class="border-main rounded-lg lg:px-8 px-3 py-4 lg:py-5 flex flex-row items-center lg:gap-x-10 gap-x-4 mb-8"
        >
          <div>
            <el-avatar class="flex items-center justify-center" :size="80">
              {{
                adminUserName.charAt(0).toUpperCase() ||
                user.firstName.charAt(0).toUpperCase()
              }}
            </el-avatar>
          </div>
          <div>
            <p class="font-normal text-fg-muted text-13px mb-1">Name</p>
            <p class="font-normal text-fg-muted text-base">
              {{ adminUserName || user.firstName + ' ' + user.lastName }}
            </p>
          </div>
        </div>
        <div class="border-main rounded-lg mb-8">
          <div class="border-b" id="settingsTourItem1">
            <p
              class="lg:px-10 px-3 text-root-2 font-bold text-base lg:py-6 py-3"
            >
              Contact Information
            </p>
          </div>
          <div
            class="mt-10 lg:px-10 px-3 flex items-center lg:gap-x-52 gap-x-3 pb-8"
          >
            <div>
              <p class="font-normal text-fg-muted text-13px mb-1">Email</p>
              <p class="font-normal text-fg-muted text-base">
                {{ user.email || adminBusinessEmail || '--' }}
              </p>
            </div>
            <div>
              <p class="font-normal text-fg-muted text-13px mb-1">
                Phone Number
              </p>
              <p class="font-normal text-fg-muted text-base">
                {{ user.telephone || adminBusinessPhone || '--' }}
              </p>
            </div>
          </div>
        </div>
        <div class="border-main rounded-lg mb-8">
          <div class="border-b">
            <p
              class="lg:px-10 px-3 text-root-2 font-bold text-base lg:py-6 py-3"
            >
              Business Information
            </p>
          </div>
          <div
            class="mt-10 flex items-center lg:px-10 px-3 pb-8 grid grid-cols-2"
          >
            <div class="col-span-1">
              <p class="font-normal text-fg-muted text-13px mb-2">
                Business Name
              </p>
              <p class="font-normal text-black-10 md:text-base text-sm">
                {{ business.name || adminBusinessName || '--' }}
              </p>
            </div>

            <div class="col-span-1">
              <p class="font-normal text-fg-muted text-13px mb-2">Website</p>
              <p class="font-normal text-black-10 md:text-base text-sm">
                {{ business.websiteUrl || adminBusinessWebsite || '--' }}
              </p>
            </div>
          </div>
          <div class="flex items-center mb-4 grid grid-cols-2 lg:px-10 px-3">
            <div class="mb-2 col-span-1">
              <p class="font-normal text-fg-muted text-13px mb-2">
                Business Type
              </p>
              <p
                class="font-normal uppercase text-fg-muted md:text-base text-sm"
              >
                {{ business.businessType || adminBusinessType || '--' }}
              </p>
            </div>
            <div class="col-span-1">
              <p
                class="font-normal text-fg-muted text-13px mb-2 text-sm flex flex-col md:flex-row md:items-center items-start"
              >
                Access
                <span class="text-black-10 border py-1 px-3 rounded-full ml-1">
                  {{ currentUserKind.title || '--' }}
                </span>
              </p>
              <p class="font-normal text-black-10 md:text-13px text-sm">
                {{ currentUserKind.access || '--' }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <initiate-tour-button
      v-if="isUserKindOwner"
      @startTour="startSettingsTour"
    />
    <app-tour
      :tourDetails="settingsTour"
      tourComponent="settings"
      :displayTour="displayTour"
      @stopTour="stopTour"
    />
  </section>
</template>

<script>
import {
  SETTINGS_TOUR,
  USER_EMAIL,
  ADMIN_BUSINESS_NAME,
  USER_PHONE,
  USER_BUSINESS_TYPE,
  USER_WEBSITE,
  USER_NAME
} from '@/utils/constants'
import fetchAllTours from '@/mixins/appTourApi.js'
import userKinds from '@/mixins/userKinds.js'

export default {
  mixins: [fetchAllTours, userKinds],
  data () {
    return {
      displayTour: false,
      settingsTour: SETTINGS_TOUR,
      isLoading: false
    }
  },
  components: {
    InitiateTourButton: () =>
      import('@/components/v2/app-tour/InitiateTourButton.vue'),
    AppTour: () => import('@/components/v2/app-tour/AppTour.vue'),
    BusinessOverviewLoader: () =>
      import('@/components/v2/skeletalLoaders/BusinessOverviewLoader.vue')
  },
  computed: {
    business () {
      return this.$store.state.auth.business
    },
    user () {
      return this.$store.state.auth.user
    },
    isANewUser () {
      return !this.$store.state.appTour.allTours.settings
    },
    adminBusinessName () {
      return localStorage.getItem(ADMIN_BUSINESS_NAME)
        ? localStorage.getItem(ADMIN_BUSINESS_NAME)
        : ''
    },
    adminBusinessEmail () {
      return localStorage.getItem(USER_EMAIL)
        ? localStorage.getItem(USER_EMAIL)
        : ''
    },
    adminUserName () {
      return localStorage.getItem(USER_NAME)
        ? localStorage.getItem(USER_NAME)
        : ''
    },
    adminBusinessPhone () {
      return localStorage.getItem(USER_PHONE)
        ? localStorage.getItem(USER_PHONE)
        : ''
    },
    adminBusinessType () {
      return localStorage.getItem(USER_BUSINESS_TYPE)
        ? localStorage.getItem(USER_BUSINESS_TYPE)
        : ''
    },
    adminBusinessWebsite () {
      return localStorage.getItem(USER_WEBSITE)
        ? localStorage.getItem(USER_WEBSITE)
        : ''
    }
  },
  methods: {
    startSettingsTour () {
      this.$tours.SettingsTour.start()
      this.displayTour = true
      this.$store.dispatch('appTour/updateSettingsTourStatus', true)
    },
    stopTour () {
      this.displayTour = false
      this.$store.dispatch('appTour/updateSettingsTourStatus', false)
    }
  },
  async mounted () {
    await this.fetchAllTours()
    if (this.isANewUser && this.isUserKindOwner) {
      this.startSettingsTour()
    }
  }
}
</script>

<style scoped>
>>> .el-avatar {
  font-size: 30px;
  border: 3px solid var(--border-main);
  background: rgba(1, 5, 44, 0.8);
}
</style>
